<button (click)="onPush()">Push</button>&nbsp;<button (click)="onDelete()">Delete</button>
